import { css } from '@emotion/react';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import PropertyOwnerInvite from './PropertyOwnerInvite';
import CTAButton from '../../../CTAButton';
import RadioButton from '../../../ComponentLibrary/input-elements/oc-radio-button';
import TextInput from '../../../ComponentLibrary/input-elements/oc-text-input';
import BackButton from '../../shared/BackButton';
import LeakingModal from '../helpers/leaking-modal';
import { decrementStep, setFormData, showLeakingModal } from '../redux/action';
import Tooltip from '../tooltip';

const spaceBtwn = css`
  display: flex;
  justify-content: space-between;

  span {
    font-size: 12px;
  }
`;

const Step5 = () => {
  const dispatch = useDispatch();
  const formData = useSelector(state => state.formData);

  const clearValues = () => {
    dispatch(setFormData({ showInvitePropertyOwner: false, showManualEntry: false }));
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const enableBtn = () =>
    formData.roofExperiencing &&
    formData.roofExperiencingComments.length > 3 &&
    formData.roofExperiencingComments.length < 500 &&
    formData.roofExperiencing !== 'Leaking';

  return (
    <>
      {formData.showInvitePropertyOwner && <PropertyOwnerInvite clearValues={clearValues} />}
      {!formData.showInvitePropertyOwner && (
        <div>
          <BackButton
            analytics={{
              'data-track': 'form-back',
              'data-track-form-name': 'Submit Claim',
              'data-track-form-step': 'step 5 - your roofing experience',
            }}
            onClick={() => dispatch(decrementStep())}
            backText={"What's your name?"}
          />
          <p>Thank you! Now, we want to learn a little more about the trouble you've been having with your roof. </p>

          <div className="txtContainer">
            <h4>What is the concern you're experiencing on your roof?</h4>

            <div
              onChange={event => {
                dispatch(setFormData({ roofExperiencing: event.target.value }));
                if (event.target.value === 'Leaking') dispatch(showLeakingModal());
              }}
            >
              <div className="radioContainer" css={spaceBtwn}>
                <RadioButton
                  name="roofExperiencing"
                  value="Granule Loss"
                  defaultChecked={formData.roofExperiencing === 'Granule Loss'}
                >
                  Granule Loss
                </RadioButton>
                <Tooltip
                  title="Granule Loss"
                  info="Granules are coming off shingles, and you can see areas of exposed material under the granules, which may include significant granules in gutters."
                />
              </div>
              <div className="radioContainer" css={spaceBtwn}>
                <RadioButton
                  name="roofExperiencing"
                  value="Blow Off"
                  defaultChecked={formData.roofExperiencing === 'Blow Off'}
                >
                  Shingle Blow Off
                </RadioButton>
                <Tooltip
                  title="Shingle Blow Off"
                  info="One or multiple shingles have physically come off of the roof"
                />
              </div>
              <div className="radioContainer" css={spaceBtwn}>
                <RadioButton
                  name="roofExperiencing"
                  value="Cracking"
                  defaultChecked={formData.roofExperiencing === 'Cracking'}
                >
                  Cracking
                </RadioButton>
                <Tooltip title="Cracking" info="Visible cracks within the shingles either vertical or horizontal" />
              </div>
              <div className="radioContainer" css={spaceBtwn}>
                <RadioButton
                  name="roofExperiencing"
                  value="Shading"
                  defaultChecked={formData.roofExperiencing === 'Shading'}
                >
                  Color Variation/Shading
                </RadioButton>
                <Tooltip
                  title="Color Variation/Shading"
                  info="Difference in the color of the shingles across various slopes of the roof"
                />
              </div>
              {/* find matching type */}
              <div className="radioContainer" css={spaceBtwn}>
                <RadioButton
                  name="roofExperiencing"
                  value="Deformation"
                  defaultChecked={formData.roofExperiencing === 'Deformation'}
                >
                  Shingles Not Laying Flat
                </RadioButton>
                <Tooltip
                  title="Shingles Not Laying Flat"
                  info="Shingles may be cupping or lifting up in areas creating a raised area exposing the roof underneath"
                />
              </div>
              <div className="radioContainer">
                <RadioButton
                  name="roofExperiencing"
                  value="Leaking"
                  defaultChecked={formData.roofExperiencing === 'Leaking'}
                >
                  Leaking
                </RadioButton>
              </div>
              <div className="radioContainer">
                <RadioButton
                  name="roofExperiencing"
                  value="Other"
                  defaultChecked={formData.roofExperiencing === 'Other'}
                >
                  Other
                </RadioButton>
              </div>
            </div>

            <div className="txtContainer">
              <div
                css={css`
                  display: flex;
                  justify-content: space-between;

                  span {
                    font-size: 12px;
                  }
                `}
              >
                <h4>Comments (Required)</h4>
                <span>
                  {formData.roofExperiencingComments && formData.roofExperiencingComments.length > 0
                    ? `${250 - formData.roofExperiencingComments.length} remaining`
                    : '250 character limit'}
                </span>
              </div>
              <div className="mb10">
                <TextInput
                  required
                  name="comments"
                  multiline
                  value={formData.roofExperiencingComments || ''}
                  placeholder="Please describe what you are experiencing on your roof to help us understand the extent of the issue."
                  onChange={event =>
                    event.target.value.length <= 250 &&
                    dispatch(
                      setFormData({
                        roofExperiencingComments: event.target.value,
                      })
                    )
                  }
                  valid={formData.roofExperiencingComments.length <= 250}
                />
              </div>
            </div>
          </div>

          <CTAButton
            data-track="form-advance"
            data-track-form-name="Submit Claim"
            data-track-form-step="step 5 - your roofing experience"
            onClick={() => dispatch(setFormData({ showInvitePropertyOwner: true }))}
            disabled={!enableBtn()}
            element="button"
            text="Next"
            type="submit"
          />
        </div>
      )}
      <LeakingModal />
    </>
  );
};

export default Step5;
